import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Pane from 'components/Common/Pane'
import config from 'constants/config'
import Heading from 'LuxKit/Typography/Heading'
import HowItWorksItems from 'components/Common/HowItWorks/HowItWorksItems'

const SizedHowItWorks = styled(HowItWorksItems)`
  min-width: ${rem(320)};
`

function HowItWorksBanner() {
  return <Pane border="neutral-five" borderRadius="S" padding="40 20">
    <Heading variant="heading3" align="center">
      Why you should book with us
    </Heading>
    <SizedHowItWorks items={config.offerList.howItWorks.hotel} />
  </Pane>
}

export default React.memo(HowItWorksBanner)
